import type {
  PlatformWalletBalanceThreshold,
  PlatformWalletBalanceThresholdStatus,
} from '@/types'

export const resolveThresholdColorScheme = (
  status?: PlatformWalletBalanceThresholdStatus
): 'red' | 'yellow' | 'green' | 'gray' => {
  switch (status) {
    case 'below':
      return 'red'
    case 'near':
      return 'yellow'
    case 'healthy':
      return 'green'
    default:
      return 'gray'
  }
}

export const resolveMostSevereThresholdStatus = (
  thresholds?: PlatformWalletBalanceThreshold[]
): PlatformWalletBalanceThresholdStatus | undefined => {
  if (!thresholds || thresholds.length === 0) {
    return undefined
  }
  const statuses = thresholds.map(threshold => threshold.status)
  if (statuses.includes('below')) {
    return 'below'
  }
  if (statuses.includes('near')) {
    return 'near'
  }
  return statuses.includes('healthy') ? 'healthy' : undefined
}
